export default __webpack_public_path__ + "assets/Logo.8dd1.svg";